export default __webpack_public_path__ + "static/media/sushi.820fa394.jpg";